import { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { CarouselContext } from './CarouselContext';
import CarouselOverlay from './CarouselOverlay';

/**
 * @typedef {Object} CarouselProps
 * @property {JSX.Element[]} slides - The slides to display in the carousel.
 * @property {number} [activeIndex] - The index of the slide to display.
 * @property {function} onMediaChange - The function to call when the active slide changes.
 * @property {JSX.Element} [children] - The content to display in the carousel overlay.
 */

/**
 * @typedef {function} Carousel
 * @param {CarouselProps} param
 * @returns  {JSX.Element | JSX.Element[]}
 */
export default function Carousel({ slides, activeIndex = 0, onMediaChange, children }) {
    const [currentIndex, setCurrentIndex] = useState(activeIndex);

    // Select the child with the matching index
    const visibleSlide = slides[currentIndex];

    useEffect(() => {
        // if onMediaChange is provided, call it when currentIndex changes
        if (onMediaChange) onMediaChange(currentIndex);
    }, [currentIndex]);

    const handleNext = () => {
        setCurrentIndex(prevCurrentIndex => (prevCurrentIndex + 1) % slides.length);
    };

    const handlePrev = () => {
        setCurrentIndex(prevCurrentIndex => (prevCurrentIndex - 1 + slides.length) % slides.length);
    };

    const handleSetIndex = index => {
        setCurrentIndex(index);
    };

    return (
        <CarouselContext.Provider value={{ currentIndex, slides, handleNext, handlePrev, handleSetIndex }}>
            <Box sx={{ height: 1, width: 1, position: 'relative', bgcolor: 'common.black' }}>
                {/* Content */}
                <Box
                    sx={{
                        width: 1,
                        height: 1,

                        position: 'relative'
                    }}
                >
                    {/* Media */}
                    {visibleSlide}
                </Box>

                {/* Overlay */}
                <CarouselOverlay>{children}</CarouselOverlay>
            </Box>
        </CarouselContext.Provider>
    );
}
